"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.setMetadata = exports.checkForMetaTag = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _storyblokJsClient = _interopRequireDefault(require("storyblok-js-client"));

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var storyblokClient = function storyblokClient(accessToken) {
  return new _storyblokJsClient.default({
    accessToken: accessToken,
    cache: {
      clear: 'auto',
      type: 'memory'
    }
  });
};

var checkForMetaTag = function checkForMetaTag(id) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var element = document.getElementById(id);

  if (!element) {
    element = document.createElement('meta');
    if (property) element.setAttribute('property', property);
    if (name) element.setAttribute('name', property);
  }

  return element;
};

exports.checkForMetaTag = checkForMetaTag;

var setMetadata = function setMetadata(res) {
  if (res.data.story.content.seo) {
    var metadataTag = checkForMetaTag('metadataTitle');
    var metaOgTitle = checkForMetaTag('metaOgTitle', 'og:title');
    var metaOgImage = checkForMetaTag('metaOgImage', 'og:image');
    var metaOgDescription = checkForMetaTag('metaOgDescription', 'og:description');
    var metaOgUrl = checkForMetaTag('metaOgUrl', 'og:url');
    var metaTwitterTitle = checkForMetaTag('metaTwitterTitle', null, 'twitter:title');
    var metaTwitterDescription = checkForMetaTag('metaTwitterDescription', null, 'twitter:description');
    var metaTwitterImage = checkForMetaTag('metaTwitterImage', null, 'twitter:image');

    if (res.data.story.content.seo.title) {
      var _res$data$story$conte = res.data.story.content.seo,
          title = _res$data$story$conte.title,
          og_image = _res$data$story$conte.og_image,
          og_title = _res$data$story$conte.og_title,
          description = _res$data$story$conte.description,
          twitter_image = _res$data$story$conte.twitter_image,
          twitter_title = _res$data$story$conte.twitter_title,
          og_description = _res$data$story$conte.og_description,
          og_url = _res$data$story$conte.og_url,
          twitter_description = _res$data$story$conte.twitter_description;
      metadataTag.setAttribute('content', description);
      metadataTag.setAttribute('title', title);
      document.title = title; // setting meta tags for facebook and linkedin

      metaOgTitle.setAttribute('content', og_title);
      metaOgImage.setAttribute('content', og_image);
      metaOgDescription.setAttribute('content', og_description);
      metaOgUrl.setAttribute('content', og_url || ''); // setting meta tags for twitter

      metaTwitterTitle.setAttribute('content', twitter_title);
      metaTwitterDescription.setAttribute('content', twitter_description);
      metaTwitterImage.setAttribute('content', twitter_image);
    }
  }
};

exports.setMetadata = setMetadata;

var StoryBlok = /*#__PURE__*/function () {
  function StoryBlok() {
    (0, _classCallCheck2.default)(this, StoryBlok);
  }

  (0, _createClass2.default)(StoryBlok, null, [{
    key: "get",
    value: function () {
      var _get = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(route, accesstoken, version) {
        var options,
            client,
            res,
            _res$data$story$conte2,
            body,
            theme,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
                _context.prev = 1;
                client = storyblokClient(accesstoken);
                _context.next = 5;
                return client.get("cdn/stories/".concat(route), Object.assign({
                  version: version
                }, options));

              case 5:
                res = _context.sent;
                setMetadata(res);
                _res$data$story$conte2 = res.data.story.content, body = _res$data$story$conte2.body, theme = _res$data$story$conte2.theme;
                return _context.abrupt("return", [body, theme.filename]);

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                throw new Error(_context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11]]);
      }));

      function get(_x, _x2, _x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }() // takes a array of strings in key value pairs and returns mui with style strings
    // ex ['color: black'] = { color: 'black' }

  }, {
    key: "arrayToMuiStyles",
    value: function arrayToMuiStyles() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var defaultStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var styleKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'root';
      var stylesObj = {};
      array.forEach(function (pair) {
        var _pair$split = pair.split(': '),
            _pair$split2 = (0, _slicedToArray2.default)(_pair$split, 2),
            key = _pair$split2[0],
            value = _pair$split2[1];

        stylesObj[key.trim()] = value.trim();
      });
      var useStyles = (0, _styles.makeStyles)((0, _defineProperty2.default)({}, styleKey, _objectSpread(_objectSpread({}, stylesObj), defaultStyles)));
      return useStyles();
    }
  }, {
    key: "anchorOrginToObj",
    value: function anchorOrginToObj(array) {
      var obj = {};

      if (array.length) {
        var splitArr = array[0].split(',');
        splitArr.forEach(function (pair) {
          var _pair$split3 = pair.split(': '),
              _pair$split4 = (0, _slicedToArray2.default)(_pair$split3, 2),
              key = _pair$split4[0],
              value = _pair$split4[1];

          obj[key.trim()] = value.trim();
        });
      }

      return obj;
    }
  }]);
  return StoryBlok;
}();

var _default = StoryBlok;
exports.default = _default;